/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Deceased_ConfirmInputs */



/**
* | output |
* | --- |
* | "Register anyway" |
*
* @param {Add_Player_Deceased_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_deceased_confirm = /** @type {((inputs?: Add_Player_Deceased_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Deceased_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrire quand même")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscribir de todas formas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrever mesmo assim")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscrivi comunque")
	return /** @type {LocalizedString} */ ("Register anyway")
});